import { useUserStore } from '../store/storeHooks'
import { useEffect } from 'react'
import { useRouter } from '@sceneio/cms-hooks/lib/useRouter'
import { useInternalGraphql } from '@sceneio/cms-hooks/lib/useInternalGraphql'

export function useCheckProjectInUrl() {
  const router = useRouter()
  const { selectedProject } = useUserStore()
  const { sendRequest: searchProjectById } = useInternalGraphql({
    query: 'UserAssignedProjectsSearchByIdDocument',
    runOnInit: false,
  })

  useEffect(() => {
    const timerId = setTimeout(() => {
      const { groups } =
        window.location.href.match(/\/project\/(?<projectId>.*?)(\/|$)/) || {}

      const { projectId: urlProjectId } = groups || {}

      const loggedInProjectId = selectedProject?.id

      // no projectId in url (e.g. magic link)
      if (!urlProjectId) {
        return
      }

      if (loggedInProjectId === urlProjectId) {
        return
      }

      searchProjectById({ variables: { id: urlProjectId } }).then(
        ({ data }) => {
          const projectsFound = data?.assignedProjects || []
          if (!projectsFound.length) {
            router.pushRoute('unauthorized')
            return
          }
          return
        },
      )
    }, 100)

    return () => clearTimeout(timerId)
  }, [window.location.href])
}
